import util from '../util'

let controller = 'ExpBACENContato'

export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'delete']), {})
